import { addPopupAction, LAYER } from 'js/components/common/PopupManager';
import { ManagedConfirmationPopup } from './ConfirmationPopup';

export const showConfirmationPopupAction = ({
    id,
    onAccept,
    onDecline,
    acceptBtnText,
    declineBtnText,
    isModal = true,
    articleId,
    ...other
}) =>
    addPopupAction({
        id,
        layer: LAYER.COMMON,
        onAccept,
        onDecline,
        acceptBtnText,
        declineBtnText,
        isModal,
        articleId,
        ...other,
        component: ManagedConfirmationPopup
    });
